export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9YHZ5nXwJxArepw.a55e9f53.woff2";